export const AgeThresholds = [40, 50, 60, 70];
export const AgeCoefficients = [1, 1, 0.91, 0.86, 0.81];
